import React from 'react';
import { InputField } from '../../../types/Forms';
import { InputBuilderProps } from './Common/Types';
import { PasswordInput, Stack } from '@mantine/core';
import Actions from './Common/Actions';
import { getId } from '../FieldConfiguration/Common/Utils';
import { styles } from './Common/Styles';

export const getExamplePassword = (): InputField => ({
	label: 'Password',
	type: 'password',
	key: `password-${getId()}`,
	name: `password-${getId()}`,
	description: 'Enter your password',
	placeholder: '********',
	validation: {
		required: true,
		minLength: 8,
	},
});

const PasswordBuilder = ({
	field,
	isEditing,
	onEditing,
	onDeleting,
	isSignup,
	onChangeText,
}: InputBuilderProps) => {
	const { value, label, description, placeholder, validation } = field;

	return (
		<Stack style={isEditing ? styles.containerEditing : styles.container}>
			<PasswordInput
				label={label}
				description={description}
				placeholder={placeholder}
				required={validation.required}
				pattern={validation.pattern}
				value={value}
				onChange={(event) => {
					const value = event.currentTarget.value;
					onChangeText?.({ ...field, value });
				}}
				disabled={!isSignup}
			/>

			{!isSignup ? (
				<Actions onEditing={onEditing} onDeleting={onDeleting} />
			) : undefined}
		</Stack>
	);
};

export default PasswordBuilder;
